enum BreadcrumbsCommon {
    HOME_LINK_LABEL = 'Home',
    HOME_LINK_URL = 'https://www.volkswagen.it/',
    HOME_VIC_LINK_URL = 'https://www.volkswagen-veicolicommerciali.it/it.html',
    PROMOTIONS_LISTING_LINK_LABEL = 'Promozioni',
    PROGRAMMATIC_NAVIGATION_LINK = '#', // programmatic navigation
    PROMOTIONS_LISTING_LINK_ROUTE = '/', // programmatic navigation
}

export default BreadcrumbsCommon
